module.exports = __webpack_public_path__ + "img/seating1.b56315c9.png";